import RadioDisplay from "./RadioDisplay";
import { Radio, sendRadio, SendRadioProps } from "src/pods/radio";
import { useToolkitRadioStore } from "src/pods/radio/toolkitRadioStore";
import { displayClose } from "src/pods/realtime";
import PresentationPage from "src/shared/components/PresentationPage";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";

export default function RadioDisplayContainer() {
  const radio = useToolkitRadioStore() as Radio;

  return (
    <PresentationPage variant="radio" onRequestHide={() => dispatchToolkitReduxAction(displayClose())}>
      <RadioDisplay
        displayClose={() => dispatchToolkitReduxAction(displayClose())}
        channel={radio.channel}
        currentTrackIndex={radio.currentTrackIndex}
        playing={radio.playing}
        sendRadio={(params: SendRadioProps) => dispatchToolkitReduxAction(sendRadio(params))}
      />
    </PresentationPage>
  );
}
